import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { toAbsoluteUrl } from "sr/helpers";
import { ModelBottomItem } from "./SidebarItems";
import { ProfileSwitcherOptions } from "app/pages/module/auth/ProfileSwitcher";
import { RefreshCw } from "lucide-react";
import { FormattedMessage, useIntl } from "react-intl";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { useAuth } from "app/pages/module/auth";
import { useDispatch, useSelector } from "react-redux";
import { fetchSupervisor } from "sr/redux/reducers/supervisor";
import { AppDispatch, RootState } from "sr/redux/store";
import { useSocket } from "app/pages/component/SocketContext";
import { formatISO } from "date-fns";
import { DaysConverter } from "sr/helpers/functions/DaysConverter";
import { fetchCompany } from "sr/redux/reducers/company";
import {
  fetchChat,
  removeNotificationMessage,
  updateSystemMessage,
} from "sr/redux/reducers/notification";
import { updateMessage } from "sr/utils/api/cleaner/updateMessage";
import { ConditionalWrapper } from "app/pages/module/auth/ConditionalWrapper";
import { NotificationLink } from "sr/helpers/functions/NotificationLink";
import {
  fetchCompanyChat,
  updateUnreadChatCount,
} from "sr/redux/reducers/companychat";
import { getUserFullProfile } from "sr/utils/api/user/user";
import { deleteMessage } from "sr/utils/api/cleaner/deleteMessage";
import { readMessage } from "sr/utils/api/cleaner/readMessage";
export const Header = (props) => {
  const intl = useIntl();
  const { logout } = useAuth();
  const [model, setModel] = useState(false);
  const [userId, serUserId] = useState();
  const [showeffect, setShowEffect] = useState(false);
  const [notificationPopup, setNotificationPopup] = useState(false);
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const [userFullProfile, setUserFullProfile] = useState<any>({});
  const messageData = useSelector((state: any) => state.chat.data);
  const messageDataRef = useRef(messageData);
  const unreadMessages = useSelector((state: any) => state.companychat.data);
  const unreadMessageRef = useRef(unreadMessages);
  const appSettingsData = useSelector((s: RootState) => s.appSettings.data);
  const appSettingsReloadSetting = useSelector(
    (s: RootState) => s.appSettings.reloadSetting
  );

  const dispatch = useDispatch<AppDispatch>();
  const audioFile = toAbsoluteUrl(
    "/media/notification/notification-18-270129.mp3"
  );
  const { userType } = useAuth();

  const data = useSelector((state: any) => {
    return userType === "company" ? state.company.data : state.supervisor.data;
  });
  const handleRemove = async (id?: any) => {
    try {
      const payload = {
        id: id,
        readed: true,
      };
      const updateMessagePayload = messageData?.map((item: any) => ({
        ...item,
        readed: true,
      }));
      const res = await updateMessage(id ? payload : updateMessagePayload);
      if (res?.success === true) {
        dispatch(removeNotificationMessage({ id: id }));
      }
    } catch (e) {}
  };

  useEffect(() => {
    const getdetails = getUserDetails();
    serUserId(getdetails.user_id);
  }, []);
  useEffect(() => {
    (async () => {
      const userFullProfileRes = await getUserFullProfile();
      setUserFullProfile(userFullProfileRes?.data);
    })();
  }, [appSettingsReloadSetting]);
  useEffect(() => {
    if (userId && userType) {
      if (userType === "company") {
        if (!data) {
          dispatch(fetchCompany({ id: userId }));
        }
      } else {
        if (!data) {
          dispatch(fetchSupervisor({ id: userId }));
        }
      }
    }
  }, [userId, userType]);
  useEffect(() => {
    if (userId) {
      if (userType === "company") {
        if (!messageData) {
          dispatch(fetchChat({ userId: userId }));
        }
        if (!unreadMessages) {
          dispatch(fetchCompanyChat({ companyId: userId }));
        }
      } else {
      }
    }
  }, [userId]);
  /* Open/End Model Popup With Effects */
  const HandleModel = () => {
    if (notificationPopup) {
      setNotificationPopup(false);
    }
    if (!model) {
      setModel(true);
      setTimeout(() => {
        setShowEffect(true);
      }, 200);
    } else {
      setTimeout(() => {
        setShowEffect(false);
      }, 200);
      setTimeout(() => {
        setModel(false);
      }, 500);
    }
  };
  useEffect(() => {
    messageDataRef.current = messageData;
  }, [messageData]);

  const handleDelete = async (id?: string) => {
    try {
      if (!userId || !id) return;

      if (id.startsWith('temp_')) {
          dispatch(removeNotificationMessage({ id }));
          return;
      }

      const payload = {
        recipient_id: userId,
        id,
      };

      const res = await deleteMessage(payload);

      if (res?.success === true) {
        dispatch(removeNotificationMessage({ id }));
      }
    } catch (e) {
      console.error(e);
    }
  };

  const socket = useSocket();
  useEffect(() => {
    if (!userId || !socket) return;

    socket.emit("register", userId);

    const handleSendMessage = ({ messagewithFullData: message }) => {
      if (message) {
        if (message?.sender_id_type !== "cleaner") {
            return;
        }

        const urlParams = new URLSearchParams(window.location.search);
        const currentJobId = urlParams.get("jobId");
        const currentCleanerId = urlParams.get("cleanerId");

        const msgJobId = typeof message.job_id === 'string' ? message.job_id : (message.job_id?._id || message.job_id?.id);
        const msgSenderId = typeof message.sender_id === 'string' ? message.sender_id : (message.sender_id?._id || message.sender_id?.id);

        const isCurrentlyViewing = window.location.pathname.includes('/messages') && currentJobId === msgJobId && currentCleanerId === msgSenderId;

        const audio = new Audio(audioFile);
        audio
          .play()
          .catch((error) => console.error("Audio playback failed:", error));

        dispatch(updateUnreadChatCount(message));
        
        const currentDateTime = formatISO(new Date());
        const tempId = message?._id || `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        const newmessage = { createdAt: currentDateTime, _id: tempId, ...message };
        
        dispatch(
          updateSystemMessage([...(messageDataRef.current || []), newmessage])
        );

        if (isCurrentlyViewing) {
            setTimeout(() => {
                const updated = messageDataRef.current?.map((item: any) => 
                    item._id === tempId ? { ...item, readed: true } : item
                );
                if (updated) {
                    dispatch(updateSystemMessage(updated));
                }
            }, 2500);
        }
      }
    };
    const handleNotificationMessage = (message) => {
      if (message) {
        const audio = new Audio(audioFile);
        audio
          .play()
          .catch((error) => console.error("Audio playback failed:", error));
        const currentDateTime = formatISO(new Date());
        const newmessage = { createdAt: currentDateTime, ...message };
        dispatch(
          updateSystemMessage([...(messageDataRef.current || []), newmessage])
        );
      }
    };

    socket.on("sendmessage", handleSendMessage);
    socket.on("notification", handleNotificationMessage);

    return () => {
      socket.off("sendmessage", handleSendMessage);
      socket.off("notification", handleNotificationMessage);
    };
  }, [userId, socket]);

  const handleNotification = () => {
    if (messageData?.length < 1) return;
    if (model) {
      setModel(false);
    }
    if (!notificationPopup) {
      setNotificationPopup(true);
      setTimeout(() => {
        setShowEffect(true);
      }, 200);
    } else {
      setTimeout(() => {
        setShowEffect(false);
      }, 200);
      setTimeout(() => {
        setNotificationPopup(false);
      }, 500);
    }
  };
  const sortedMessage = [...(messageData || [])]?.sort((a, b) => {
    const adate = new Date(a?.createdAt);
    const bdate = new Date(b?.createdAt);
    return bdate.getTime() - adate.getTime();
  });

  const handleRead = async (id?: string) => {
    try {
      if (!userId) return;

      if (id && id.startsWith('temp_')) {
        const updated = messageData?.map((item: any) =>
            item._id === id ? { ...item, readed: true } : item
        );
        dispatch(updateSystemMessage(updated));
        return;
      }

      const payload = {
        recipient_id: userId,
        ...(id && { id }),
      };

      const res = await readMessage(payload);

      if (res?.success === true) {
        const updated = messageData?.map((item: any) =>
          id
            ? item._id === id
              ? { ...item, readed: true }
              : item
            : { ...item, readed: true }
        );

        dispatch(updateSystemMessage(updated));
      }
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <nav
      className={`${
        props.isOpen ? "pl-48" : "pl-16"
      } top-0 sticky z-20 duration-300 pr-4 flex flex-col`}
    >
      <div className="w-full flex bg-white justify-between py-1.5 border border-b-text-gray-500">
        <div className="">
          <img
            width={120}
            src={toAbsoluteUrl("/media/logos/logo2.png")}
            alt="logo"
          />
        </div>
        <div className="lg:flex block space-x-4">
          <a
            href="https://support.janijobs.com/hc/en-us"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center space-x-2"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              focusable="false"
              role="img"
              fill="currentColor"
              viewBox="0 0 20 20"
              aria-hidden="true"
              className="w-5 h-5"
            >
              <path
                fillRule="evenodd"
                d="M10 2a8 8 0 100 16 8 8 0 000-16zm0 5.497a1.25 1.25 0 00-1.152.763c-.107.254-.322.487-.598.487h-.5c-.276 0-.505-.226-.455-.498a2.752 2.752 0 015.455.498c0 .779-.369 1.326-.765 1.714-.19.186-.399.349-.608.511-.162.126-.324.251-.477.387a.538.538 0 01-.357.142H9.75c-.276 0-.507-.231-.412-.49.137-.374.42-.687.736-.94.088-.072.192-.144.3-.22.405-.281.876-.609.876-1.104A1.25 1.25 0 0010 7.497zM9.25 13.5a.5.5 0 01.5-.5h.5a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-.5a.5.5 0 01-.5-.5v-1z"
                clipRule="evenodd"
              ></path>
            </svg>
            <span>
              <FormattedMessage
                id="RECRUITER.TOPBAR.MENU.HELP"
                defaultMessage="Help"
              />
            </span>
          </a>
          <div
            onClick={handleNotification}
            className="flex items-center w-full space-x-2 relative cursor-pointer"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              focusable="false"
              role="img"
              fill="currentColor"
              viewBox="0 0 20 20"
              aria-hidden="true"
              height="24"
              className="w-5 h-5"
            >
              <path d="M10 2a1.5 1.5 0 00-1.5 1.5v.229A5.002 5.002 0 005 8.5V12l-1.854 1.854a.5.5 0 00-.146.353v.293a.5.5 0 00.5.5h13a.5.5 0 00.5-.5v-.293a.5.5 0 00-.146-.353L15 12V8.5a5.002 5.002 0 00-3.5-4.771V3.5A1.5 1.5 0 0010 2zm.002 16a2.5 2.5 0 01-2.45-2h4.9a2.5 2.5 0 01-2.45 2z"></path>
            </svg>
            <span>
              <FormattedMessage
                id="RECRUITER.TOPBAR.MENU.NOTIFICATION"
                defaultMessage="Notification"
              />
            </span>
            {messageData?.filter((m) => !m.readed).length > 0 && (
              <div className="rounded-full bg-[#ff39b3] font-bold w-4 h-4 flex justify-center items-center absolute top-0 -left-1">
                <span className="text-[0.8rem] text-white ">
                  {messageData?.filter((m) => !m.readed).length}
                </span>
              </div>
            )}
            <div
              className={`dropdown-menu transitioncss fixed ${
                notificationPopup && sortedMessage?.length > 0
                  ? "block"
                  : "hidden"
              } ${
                showeffect ? "modeleffect" : "popup"
              } w-[450px] right-10   top-10 z-50 max-h-[500px] overflow-y-scroll rounded-lg border border-2xl`}
            >
              <div className="bg-white shadow py-3 rounded-lg text-black">
                <p
                  onClick={() => handleRead()}
                  className="text-right text-sm font-bold  text-[#0078ae] pr-2 cursor-pointer"
                >
                  Mark all as read
                </p>

                {sortedMessage?.map((item) => (
                  <ConditionalWrapper
                    condition={NotificationLink(item)}
                    key={item._id}
                  >
                    <div
                      onClick={() => {
                        if (!item?.readed && item?._id) {
                          handleRead(item?._id);
                        }
                      }}
                      className="relative flex w-full items-start gap-3 p-4 cursor-pointer transition-all min-h-[90px]"
                    >
                      {/* IMAGE */}
                      <div className="flex-shrink-0">
                        <img
                          className="w-14 h-14 rounded-full object-cover"
                          src={toAbsoluteUrl(
                            "/media/icons/displayProfilePlaceholder.png"
                          )}
                          alt="profile"
                        />
                      </div>

                      {/* CONTENT */}
                      <div className="flex-1 pr-6">
                        <div className="flex justify-between">
                          <span className="text-xs text-gray-400">
                            {DaysConverter(item?.createdAt)} Ago
                          </span>
                        </div>

                        {item?.sender_id_type === "cleaner" && item?.type === "chat" && (
                          <p
                            className={`text-sm mt-1 ${
                              !item?.readed
                                ? "font-bold text-black"
                                : "text-gray-500"
                            }`}
                          >
                            New message from {item?.sender_id?.first_name || item?.sender_id?.name || "cleaner"} {item?.sender_id?.last_name || ""}
                          </p>
                        )}
                        <p
                          className={`text-sm mt-1 ${
                            !item?.readed
                              ? "font-bold text-black"
                              : "text-gray-500"
                          }`}
                        >
                          {item?.message?.slice(0, 100)}
                        </p>
                      </div>

                      {/* DELETE */}
                      <div
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          handleDelete(item?._id);
                        }}
                        className="absolute top-2 right-2 cursor-pointer p-1 rounded-full hover:bg-gray-200"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                          className="w-4 h-4"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M6 18 18 6M6 6l12 12"
                          />
                        </svg>
                      </div>
                    </div>
                  </ConditionalWrapper>
                ))}
              </div>
            </div>
          </div>

          <Link
            className="flex items-center space-x-2 border-r border-text-gray-500 pr-4 relative"
            to="/messages"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              focusable="false"
              role="img"
              fill="currentColor"
              viewBox="0 0 20 20"
              aria-hidden="true"
              className="w-5 h-5"
            >
              <path
                fillRule="evenodd"
                d="M2.5 4a.5.5 0 00-.5.5v11a.5.5 0 00.5.5h15a.5.5 0 00.5-.5v-11a.5.5 0 00-.5-.5h-15zm13.111 2.26L10 10 4.389 6.26A.25.25 0 004 6.466v.9a.25.25 0 00.111.207L10 11.5l5.889-3.926A.25.25 0 0016 7.366v-.899a.25.25 0 00-.389-.208z"
                clipRule="evenodd"
              ></path>
            </svg>
            <span>
              <FormattedMessage
                id="RECRUITER.TOPBAR.MENU.MESSAGES"
                defaultMessage="Message"
              />
            </span>
            {unreadMessages?.length > 0 && (
              <div className="rounded-full bg-[#ff39b3] font-bold w-4 h-4 flex justify-center items-center absolute top-[0.25rem] -left-[0.4rem]">
                <span className="text-[0.8rem]  text-white">
                  {unreadMessages?.length}
                </span>
              </div>
            )}
          </Link>
          {/* <div className='flex flex-1 items-center space-x-2 border-r border-text-gray-500 pr-4' >
   <svg xmlns="http://www.w3.org/2000/svg" focusable="false" role="img" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true" className="w-5 h-5"><path fill-rule="evenodd" d="M3.5 3a.5.5 0 00-.5.5v17a.5.5 0 00.5.5H6v-6h5v6h9.5a.5.5 0 00.5-.5v-10a.5.5 0 00-.5-.5H14V3.5a.5.5 0 00-.5-.5h-10zM5 9h7v1H5V9zm7-3H5v1h7V6z" clipRule="evenodd"></path></svg>
   <div className='block'>
      <p className='-mb-1'>{data?.username}</p>
      <p className='text-[#767676] text-sm'><FormattedMessage id="RECRUITER.TOPBAR.MENU.OWNER.TITLE" defaultMessage="owner" />:{data?.email}</p>
   </div>
      </div> */}
          <Link className="flex items-center space-x-2 relative" to="#">
            <svg
              onClick={HandleModel}
              xmlns="http://www.w3.org/2000/svg"
              focusable="false"
              role="img"
              fill="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
              className="w-5 h-5"
            >
              <path d="M12 12c2.486 0 4.5-2.014 4.5-4.5S14.486 3 12 3a4.499 4.499 0 00-4.5 4.5C7.5 9.986 9.514 12 12 12zm0 2.25c-3.004 0-9 1.508-9 4.5v1.75a.5.5 0 00.5.5h17a.5.5 0 00.5-.5v-1.75c0-2.992-5.996-4.5-9-4.5z"></path>
            </svg>
            <span onClick={HandleModel}> {data?.username}</span>
            <span
              className={`transition-transform transform duration-1000 ${
                model ? "rotate-180" : ""
              }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-3 h-3"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                />
              </svg>
            </span>
            {model && (
              <div
                className={`${
                  showeffect ? "modeleffect" : "popup"
                }  w-[22rem] transitioncss z-50 absolute top-14 right-2 bg-white rounded-lg border border-slate-400	`}
              >
                <div className="p-4">
                  {/* <h1 className=' text-lg'>
        {data?.username}
    </h1>
    <ul>
        {ModelItems.map((data)=> (
        <li className='flex items-center space-x-2 py-3'>
        {data.icon}
        <span>{data.text}</span>
        </li>
        )) }
    </ul>*
    <hr className='pt-2 border-slate-300'/> */}
                  <div className="py-2">
                    <h1 className=" text-lg">{data?.username}</h1>
                    <p className="text-gray-500">{data?.email}</p>
                  </div>
                  <ul>
                    {userType === "company" && (
                      <>
                        {ModelBottomItem.map((data, index) => (
                          <Link key={index} to={data.link ? data.link : "#"}>
                            <li className="flex items-center space-x-2 py-3">
                              {data.icon}
                              <span>{data.text}</span>
                            </li>
                          </Link>
                        ))}
                        <li className="py-3">
                          <button
                            type="button"
                            onClick={() => setProfileMenuOpen(!profileMenuOpen)}
                            className="flex w-full items-center space-x-2 text-left"
                          >
                            <RefreshCw className="w-5 h-5" />
                            <span>Switch Profile</span>
                          </button>
                          {profileMenuOpen && (
                            <ProfileSwitcherOptions currentUserType="company" />
                          )}
                        </li>
                      </>
                    )}
                    <li
                      onClick={logout}
                      className="flex items-center space-x-2 py-3"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        focusable="false"
                        role="img"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        aria-hidden="true"
                        className="w-5 h-5"
                      >
                        <path d="M4 3a2 2 0 00-2 2v9.998a2 2 0 002 2h5.5a.5.5 0 00.5-.5v-.5a.5.5 0 00-.5-.5h-6v-11h6a.5.5 0 00.5-.5V3.5a.5.5 0 00-.5-.5H4z"></path>
                        <path d="M12.274 13.795a.5.5 0 000 .707l.354.353a.5.5 0 00.707 0l4.52-4.52a.503.503 0 00-.004-.71l-4.477-4.48a.5.5 0 00-.707 0l-.354.354a.5.5 0 000 .707l3.041 3.043H7.517a.5.5 0 00-.5.5v.5a.5.5 0 00.5.5h7.803l-3.046 3.046z"></path>
                      </svg>
                      <span>
                        <FormattedMessage
                          id="RECRUITER.TOPBAR.MENU.SIGN.OUT"
                          defaultMessage="Sign Out"
                        />
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            )}
          </Link>
        </div>
      </div>
      {appSettingsData &&
      appSettingsData?.isPlatformPaymentActive != undefined &&
      appSettingsData?.isPlatformPaymentActive === true
        ? userFullProfile &&
          userFullProfile?.id &&
          userFullProfile?.type &&
          userFullProfile?.type !== "cleaner" &&
          userFullProfile?.type !== "supervisor" &&
          (!userFullProfile?.id ||
          !userFullProfile?.stripe_customer_detail ||
          !userFullProfile?.stripe_customer_detail?.id ||
          !userFullProfile?.stripe_customer_payment_methods ||
          userFullProfile?.stripe_customer_payment_methods?.length == 0 ? (
            <div className="flex justify-center items-center gap-x-6 bg-red-400 px-6 py-2.5 sm:px-3.5">
              <p className="text-sm/6 text-white">
                {intl.formatMessage({
                  id: "API.ERROR.PAYMENTMETHOD.NOT.FOUND",
                  defaultMessage: "Please setups your payment method first",
                })}
                <Link
                  to="/company/settings?tab=payment-settings"
                  className="cursor-pointer"
                >
                  &nbsp;
                  <span aria-hidden="true">&rarr;</span>
                </Link>
              </p>
            </div>
          ) : !userFullProfile?.stripe_customer_detail ||
            !userFullProfile?.stripe_customer_detail?.default_payment_method ||
            userFullProfile?.stripe_customer_detail?.default_payment_method ==
              null ||
            userFullProfile?.stripe_customer_detail?.default_payment_method ==
              "null" ||
            userFullProfile?.stripe_customer_detail?.default_payment_method ==
              "" ? (
            <div className="flex justify-center items-center gap-x-6 bg-red-400 px-6 py-2.5 sm:px-3.5">
              <p className="text-sm/6 text-white">
                {intl.formatMessage({
                  id: "API.ERROR.PAYMENTMETHOD.DEFAULT.NOT.FOUND",
                  defaultMessage: "Please set a default payment method first",
                })}
                <Link
                  to="/company/settings?tab=payment-settings"
                  className="cursor-pointer"
                >
                  &nbsp;
                  <span aria-hidden="true">&rarr;</span>
                </Link>
              </p>
            </div>
          ) : (
            ""
          ))
        : ""}
      {model ||
        (notificationPopup && (
          <span
            onClick={() => {
              notificationPopup && handleNotification();
              model && HandleModel();
            }}
            className="fixed w-full h-full z-[40] top-0 left-0 delay-100 visible"
          ></span>
        ))}
    </nav>
  );
};
